import script from "./TheHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TheHeader.vue?vue&type=style&index=0&id=32686e84&lang=sass"

const __exports__ = script;

export default __exports__